import { render } from "./CertView.vue?vue&type=template&id=20f32607&scoped=true"
import script from "./CertView.vue?vue&type=script&lang=js"
export * from "./CertView.vue?vue&type=script&lang=js"

import "./CertView.vue?vue&type=style&index=0&id=20f32607&lang=scss&scoped=true"

import exportComponent from "D:\\software\\phpEnv\\www\\hkz-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20f32607"]])

export default __exports__